export const formatAmount = (amount?: string, locales: Intl.LocalesArgument = 'ru-RU') => {
    if (!amount) {
        return '0';
    }

    const numericAmount = Number(amount);

    if (!Number.isFinite(numericAmount)) {
        return amount;
    }

    return new Intl.NumberFormat(locales, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8,
    }).format(numericAmount);
};
